/* istanbul ignore file */
export const MAX_ANG_STREAM_SEARCH_RESULTS = 2000;
export const ANG_PAGINATION_SIZE = 20;
export const DEFAULT_SORT = 'score';
export const SOURCE_KEY = '_source';
export const ANG_TYPE = '@type';
